/**
 * Event Single Page - Sticky Sidebar
 *
 * Makes the sidebar sticky and follow the scroll until the main content reaches the end.
 * When the main content ends, the sidebar stops scrolling.
 *
 * This uses CSS sticky positioning with a constraint that stops the sidebar
 * when it reaches the end of the content area.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function eventSingleStickySidebar() {
	const sidebar = document.querySelector('[data-event-sidebar]');
	const sidebarParent = sidebar?.parentElement;
	const content = document.querySelector('[data-event-content]');

	if ( window.innerWidth < 992 || !sidebar || !content || !sidebarParent) return;

	// Set parent to relative positioning for absolute positioning context
	sidebarParent.style.position = 'relative';

	// Create ScrollTrigger to pin the sidebar
	ScrollTrigger.create({
		trigger: sidebarParent,
		start: 'top top+=30',
		end: () => `+=${content.offsetHeight - sidebar.offsetHeight}`,
		pin: sidebar,
		pinSpacing: false,
		invalidateOnRefresh: true,
	});

	// Refresh on window resize
	window.addEventListener('resize', () => {
		ScrollTrigger.refresh();
	});
}

export default eventSingleStickySidebar;

